<template>
   <div>
       <Head>
            <template v-slot:title>
                <span style="margin-left:30%;">面试管理</span>
            </template>
       </Head>
       <el-row class="zw_nav">
            <el-col>
                <div class="grid-content bg-purple-dark nav-box">
                      <ul class="nav clearfix">
                          <li :class="{active:isActive=='0'}" @click="show('0','#1A80FC')" style="">待接收
                              <!-- <span class="icon" style="background-color: #1A80FC;">
                              </span> -->
                          </li>
                          <li :class="{active:isActive=='1'}"  @click="show('1','#79E46E')">待面试
                              <!-- <span class="icon" style="background-color: #79E46E;">
                              </span> -->
                          </li>
                          <li :class="{active:isActive=='2'}" @click="show('2','#F43E21') ">已拒绝
                              <!-- <span class="icon" style="background-color: #F43E21;">
                              </span> -->
                          </li>
                          <li :class="{active:isActive=='3'}"  @click="show('3','#EEF2FB') ">已过期
                              <!-- <span class="icon" style="background: #EEF2FB;">
                              </span> -->
                          </li>
                      </ul>
                </div>
            </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="center" v-cloak>
            <el-col :span="14" style="height:100%;">
                <el-card ref="card" class="box-card interview-card" style="position:relative" v-for="(item,index) in userInfo" :key="index">
                    <el-col :span="4" class="userBox" style="height:100%;">
                        <div class="text item">
                            <el-avatar :size="68" :src="userInfo.headPortrait"></el-avatar>
                            <div class="name" style="margin:0 auto;">{{item.name}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8" :offset="1">
                        <div class="text item user-info">
                            <p class="info"><span>时间：</span>{{item.interviewTime}}</p>
                            <p class="info"><span>职业：</span>{{item.postName}}</p>
                            <p class="info"><span>地址：</span>{{item.companyAddress}}</p>
                            <p class="info"><span>联系人：</span>{{item.contact}}</p>
                            <p class="info"><span>手机号码：</span>{{item.phone}}</p>
                        </div>
                        <p style="position:absolute;bottom:10px;right:30px;font-size:16px;color: #333333;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background-color:#FAB850;position:relative;bottom:2px;right:5px;"></span><span>3月17日&#160;&#160;&#160;12:35</span></p>
                    </el-col>
                    <div :class="bgColor" ref="bgColor" style="position:absolute;top:0;right:0;width:0;height:0;border-left:solid white 47px;border-bottom:solid white 47px;"></div>
                </el-card>
            </el-col>
        </el-row>

   </div>
</template>
<script>
import Head from '@/components/header/head.vue'
export default {
    data(){
        return {
           isActive:'0',
           bgColor:'accept',
           logo:'',
           identityStatus:1,    
           userId:'',    // 获得管理员id
           userInfo:[]
        }
    },
    components:{
        Head
    },
    methods:{
        show(index,color){
            
            // this.$nextTick(()=>{   
            //     this.isActive = index
                
            //     let bgColor = this.$refs.bgColor
            //     console.log('bgColor')
            //     console.log(bgColor)
            //     this.getInterviewData(index)
            // }) 
            this.isActive = index
            this.getInterviewData(index)
        },
        getInterviewData(type='0'){
            this.axiosGet(`/interview/findAllInterview/?userId=${this.userId}&type=${type}&identityStatus=${this.identityStatus}`
            ).then((res)=>{
                // console.log('数据已获得',type)
                // console.log(res)
                if(res.code==200){ 
                    this.userInfo = res.data
                }
            })
        }
    },
    mounted(){
        this.userId = JSON.parse(sessionStorage.getItem("userInfo")).id
        this.getInterviewData()
    },
    updated(){
        switch(this.isActive){
            case '0':
                this.bgColor = 'accept'
                break;
            case '1':
                this.bgColor = 'interview'
                break;
            case '2':
                this.bgColor = 'refuse'
                break;
            case '3':
                this.bgColor = 'overdue'
                break;
        }
        
    }
}
</script>
<style lang="less" scoped>
    .accept{
        border-top:solid #1A80FC 47px !important;
    }
    .interview{
        border-top:solid#79E46E 47px !important;
    }
    .refuse{
        border-top:solid #F43E21 47px !important;
    }
    .overdue{
        border-top:solid #EEF2FB 47px !important;
    }
    .zw_nav{
        // height:110px;   
        padding:0 22px;
            .nav-box{
                // background-color:yellow;
                background-color:#ffffff;
                height:110px;
                margin-top:15px;
                margin-bottom:15px;
            }
            .nav{
                padding:32px 0 0 303px;
                >li{
                    line-height:46px;
                    width: 128px;
                    height: 46px;
                    background: #EEF2FB;
                    box-shadow: 0px 0px 32px 6px rgba(141, 141, 141, 0.11);
                    border-radius: 8px;
                    float:left;
                    text-align:center;
                    cursor:pointer;     
                    font-size: 16px;
                    font-weight: 400;
                    color: #868EA7;
                    margin-right:50px;
                }
                li.active{        
                    background: #FFFFFF;   
                    color: #1A80FC;
                }
            }
        
        }
        .icon{
            display:block;
            width:16px;
            height:16px;
            margin:5px auto;
        }
        .name{
            width: 70px;
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
        }
        .info{  
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
            >span{
                font-size: 16px;
                font-family: "Source Han Sans CN";
                font-weight: 400;
                color: #666666;
                line-height: 40px;

            }
        }

    .userBox{
        border-right:solid #E6ECF8 1px;
        padding:20px 0;
        >div{
            text-align:center;
        }
    }
    .user-info{
        padding:10px;
    }
</style>